<template>
    <b-modal
        :id="id"
        v-model="show">
        <slot></slot>
        <div slot="modal-footer" class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="confirm"
        >
          {{text.confirm}}
        </b-button>
        <b-button
          variant="outline-dark"
          size="sm"
          class="float-right mr-2"
          @click="show = false"
        >
          {{text.close}}
        </b-button>
      </div>
    </b-modal>
</template>

<script>
import { textCommon } from '../../assets/utils/language';
export default {
  props: {
    id: String
  },
  data () {
    return {
      show: false,
      text: {}
    };
  },
  methods: {
    confirm () {
      this.$emit('confirm');
      this.show = false;
    }
  },
  watch: {
    $language: function () {
      this.text = textCommon(this.$language);
    }
  },
  mounted () {
    this.text = textCommon(this.$language);
  }
};
</script>
